/**
 * Generate a cryptographically secure client ID.
 * Jest/jsdom often has no `crypto.randomUUID`; browsers do.
 */
export function createClientId(): string {
  const c = typeof globalThis !== "undefined" ? globalThis.crypto : undefined;
  if (c && typeof c.randomUUID === "function") {
    return c.randomUUID();
  }
  // Fallback: use crypto.getRandomValues for secure randomness instead of Math.random()
  if (c && typeof c.getRandomValues === "function") {
    const array = new Uint8Array(9);
    c.getRandomValues(array);
    const randomPart = Array.from(array)
      .map((b) => b.toString(36).padStart(2, "0"))
      .join("")
      .slice(0, 9);
    return `${Date.now().toString(36)}-${randomPart}`;
  }
  // Last resort for test environments without crypto
  // Test-only fallback - production browsers have crypto.getRandomValues
  return `${Date.now().toString(36)}-${Math.random() // NOSONAR S2245 - test environment fallback only
    .toString(36)
    .slice(2, 11)}`;
}
